<!-- =========================================================================================
  File Name: UserEditTabInformation.vue
  Description: User Edit Information Tab content
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->
<style lang="scss">
input[type="text"]:hover,
input[type="text"]:focus,
input[type="email"]:hover,
input[type="email"]:focus,
input[type="password"]:hover,
input[type="password"]:focus,
.v-select:hover,
.v-select:focus,
.vue-input-tag-wrapper:hover,
.vue-input-tag-wrapper:focus {
  background: #faffbd;
}
.roundtable-image-wrap {
  width: 200px !important;
  height: 40px !important;
  border: 1px solid #dfdfdf;
}
.group-person-count {
  display: flex;
  justify-content: flex-start;
  align-items: center;
}
.group-creation-wrapper {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  flex-direction: column;
}

.input-field {
  width: 100%;
}
.ql-editor.ql-blank {
  min-height: 150px;
}
.track-wrapper {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  margin-top: 9px;
}
.track-select {
  width: 85%;
  margin-right: 15px;
}
.input-track-name {
  width: 75%;
  margin-right: 15px;
}
.add-track-inner-section {
  display: flex;
  justify-content: flex-start;
  align-items: center;
}
.rqrd {
  color: #f00;
}
.header-custome {
  margin-bottom: 15px;
  padding-left: 2px;
}
.border-1 {
  border: 1px solid #cdcdcd;
  padding: 12px;
  border-radius: 5px;
}
h2.cms-custom-heading {
  font-weight: 600;
  font-size: 24px;
  font-family: "Poppins", sans-serif;
  color: #001d4e;
}
.custom-head-wrap {
  padding-bottom: 1.25rem;
  border: 1px solid transparent;
  border-bottom: 1px solid #dfdfdf;
  padding: 10px 0;
  transition: all 0.4s;
}
.custom-head-wrap input[type="text"] {
  height: 45px;
  border: 1px solid #cbcbcb;
  border-radius: 5px;
  font-weight: 600;
  font-size: 24px;
  color: #333;
  font-family: "Poppins", sans-serif;
  line-height: 30px;
  transition: all 0.4s;
  padding: 0 15px;
  margin-bottom: 15px;
}
.attendee-form-wrap .con-slot-tabs {
  padding: 0 140px;
}
ul.streaming-client-wrap {
  border: 1px solid #4c8bf6;
  border-radius: 5px;
  display: inline-flex;
  justify-content: flex-start;
  align-items: center;
}
.streaming-client-wrap li.active {
  background: #4c8bf6;
  color: #fff;
}
ul.streaming-client-wrap li {
  border-right: 1px solid #4c8bf6;
}
ul.streaming-client-wrap li:last-child {
  border-right: none;
}
ul.streaming-client-wrap li {
  padding: 10px 15px;
  text-align: center;
  line-height: 0;
  min-width: 120px;
  max-width: max-content;
}
@media screen and (min-width: 1367px) and (max-width: 1440px) {
  .attendee-form-wrap .con-slot-tabs {
    padding: 0 0px;
  }
}
@media screen and (max-width: 1366px) {
  .attendee-form-wrap .con-slot-tabs {
    padding: 0 0px;
  }
}
</style>
<template>
  <div id="user-edit-tab-info">
    <!-- Avatar Row -->
    <div class="tab-top-part">
      <div class="vx-row">
        <div class="vx-col md:w-1/1 w-full mb-6">
          <!-- <label>
            Table Name
            <span class="rqrd">*</span>
          </label>
          <vs-input
            class="w-full mt-3"
            name="Table Name"
            v-model="data_local.TableName"
            v-validate="'required'"
          />
          <span class="text-danger text-sm" v-show="errors.has('Table Name')">{{
            errors.first("Table Name")
          }}</span> -->

          <div class="custom-head-wrap">
            <!-- <h2 class="cms-custom-heading">Session Type - {{sessionType.label}}</h2>
                <p class="mt-1 mb-0">Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s.</p> -->
            <input
              type="text"
              name="Title"
              v-validate="'required'"
              class="w-full"
              v-model="data_local.TableName"
              id=""
              value=""
              placeholder="Table Name*"
            />
            <span class="text-danger text-sm" v-show="errors.has('Title')"
              >This field is required</span
            >
          </div>
        </div>
        <div class="vx-col md:w-1/2 w-full">
          <div class="border-1">
            <div class="flex items-start flex-col sm:flex-row">
              <img
                :src="imgSrc"
                class="mr-8 rounded mt-2 roundtable-image-wrap"
              />
              <!-- <vs-avatar :src="data_local.ProfilePictureURL" size="80px" class="mr-4" /> -->
              <div>
                <p class="text-lg font-medium mb-2 mt-4 sm:mt-0"></p>
                <input
                  id="uploadAvatar"
                  type="file"
                  class="hidden"
                  ref="update_avatar_input"
                  @change="update_avatar($event, '200x100', true)"
                  accept="image/*"
                />

                <!-- Toggle comment of below buttons as one for actual flow & currently shown is only for demo -->
                <vs-button
                  class="mr-4 mb-4"
                  @click="$refs.update_avatar_input.click()"
                  >Upload</vs-button
                >
                <!-- <vs-button type="border" class="mr-4" @click="$refs.update_avatar_input.click()">Change Avatar</vs-button> -->

                <!--<vs-button type="border" color="danger">Remove Avatar</vs-button>-->
              </div>
            </div>
            <p>High quality image: 960x192 px (2:1 ratio)</p>
          </div>
        </div>

        <div class="vx-col md:w-1/2 w-full mt-4">
          <label>Select Group</label>
          <div class="track-wrapper">
            <v-select
              class="track-select"
              label="TopicDisplayName"
              v-model="data_local.Topic"
              :options="TopicList"
              v-validate="'required'"
              name="Topic"
            />
            <span class="text-danger text-sm" v-show="errors.has('Topic')">{{
              errors.first("Topic")
            }}</span>
            <vs-button color="primary" type="filled" @click="popupActive = true"
              >Add</vs-button
            >
            <!-- <div class="track-popup"> -->
            <vs-popup
              class="holamundo add-new-group-table"
              title="Add New Group"
              :active.sync="popupActive"
            >
              <!-- <div class="add-track-inner-section"></div>
              <div class="add-track-inner-section"> -->
              <!-- <vs-select
                    v-model="tableCapacity"
                    class="w-full select-large"
                    label="Table Capacity"
                  >
                    <vs-select-item
                      :key="index"
                      :value="item.value"
                      :text="item.text"
                      v-for="(item, index) in TableCapacityOptions"
                      class="w-full"
                    />
                  </vs-select> -->
              <!-- </div> -->
              <div class="w-full group-creation-wrapper">
                <label class="mb-2">Group Name </label>
                <vs-input
                  class="inputx input-track-name mb-3 w-full"
                  v-model="TopicName"
                />
                <div class="group-person-count">
                  <label class="mr-5">No of Seats </label>
                  <vs-input-number
                    class="select-large"
                    name="Table Capacity"
                    v-model="tableCapacity"
                    v-validate="'required'"
                    :min="2"
                    :max="300"
                  />
                </div>
              </div>
              <div align="right">
                <vs-button
                  color="rgb(76, 139, 246)"
                  type="filled"
                  @click="addTopic"
                  >Add Group</vs-button
                >
              </div>
            </vs-popup>
            <!-- </div> -->
          </div>
        </div>
      </div>
    
      <!-- Content Row -->
      <div class="vx-row">
        <!-- <div class="vx-col md:w-1/2 w-full mt-4">
          <label>
            Seats
            <span class="rqrd">*</span>
          </label>
          <vs-input
            class="w-full mt-3"
            type="number"
            name="Capacity"
            value="10"
            readonly
            v-model="data_local.Capacity"
            v-validate="'required'"
          />
          <span
            class="text-danger text-sm"
            v-show="errors.has('Capacity')"
          >{{ errors.first('Capacity') }}</span>
        </div>-->

        <div class="vx-col md:w-1/2 w-full mt-4">
          <label>
            Select Host
            <span class="rqrd">*</span>
          </label>
          <v-select
            class="mt-3"
            label="Email"
            :options="attendessList"
            :dir="$vs.rtl ? 'rtl' : 'ltr'"
            name="Host"
            v-model="data_local.Host"
            v-validate="'required'"
            :disabled="
              $route.params.roundtableId && data_local.StreamingClient.includes('Zoom')
            "
          />
          <span class="text-danger text-sm" v-show="errors.has('Host')">{{
            errors.first("Host")
          }}</span>
        </div>

        <div class="vx-col md:w-1/2 w-full mt-4">
          <label> Select Co Host </label>
          <v-select
            class="mt-3"
            label="Email"
            :options="attendessList"
            :dir="$vs.rtl ? 'rtl' : 'ltr'"
            name="CoHost"
            v-model="data_local.CoHost"
            :disabled="
              $route.params.roundtableId && data_local.StreamingClient.includes('Zoom')
            "
          />
        </div>
        <div class="vx-col md:w-1/2 w-full mt-4">
          <label>Approval Type</label>
            <v-select
              class="mt-3"
              label="Name"
              :clearable="false"
              :disabled="$route.params.roundtableId"
              :options="[
                {Name:'Open Meeting', id:2},
                //{Name:'Need Approval', id:1},
                {Name:'Need Registration', id:0}
              ]"
              :reduce="(option) => option.id"
              :dir="$vs.rtl ? 'rtl' : 'ltr'"
              v-model="data_local.approval_type"
            />
        </div>
        <div class="vx-col md:w-6/12 w-full mt-4">
          <label>Streaming Client</label>
          <div class="w-full mt-5">
            <ul class="streaming-client-wrap">
              <li :class="data_local.StreamingClient == 'Web' ? 'active' : ''">
                <vs-radio
                  v-model="data_local.StreamingClient"
                  vs-value="Web"
                  color="#ffffff"
                  name="StreamingClient"
                  :disabled="$route.params.roundtableId"
                  >Web</vs-radio
                >
              </li>
              <li :class="data_local.StreamingClient == 'Zoom' ? 'active' : ''">
                <vs-radio
                  class="ml-3"
                  v-model="data_local.StreamingClient"
                  vs-value="Zoom"
                  color="#ffffff"
                  name="StreamingClient"
                  :disabled="$route.params.roundtableId"
                  >Zoom Client</vs-radio
                >
              </li>
              <li
                :class="data_local.StreamingClient == 'ZoomWeb' ? 'active' : ''"
              >
                <vs-radio
                  class="ml-3"
                  v-model="data_local.StreamingClient"
                  vs-value="ZoomWeb"
                  name="StreamingClient"
                  color="#ffffff"
                  :disabled="$route.params.roundtableId"
                  >Zoom Web</vs-radio
                >
              </li>
              <li :class="data_local.StreamingClient == 'Custom' ? 'active' : ''">
                <vs-radio
                  class="ml-3"
                  v-model="data_local.StreamingClient"
                  vs-value="Custom"
                  color="#ffffff"
                  name="StreamingClient"
                  :disabled="$route.params.roundtableId"
                  >Custom</vs-radio
                >
              </li>
            </ul>
          </div>
        </div>
        <div class="vx-col md:w-1/2 w-full mt-4" v-if="data_local.StreamingClient == 'Custom'">
          <label>
            Custom Link
            <span class="rqrd">*</span>
          </label>
          <vs-input
            class="w-full mt-3"
            name="CustomLink"
            v-model="data_local.CustomLink"
            v-validate="'required'"
          />
          <span
            class="text-danger text-sm"
            v-show="errors.has('CustomLink')"
          >{{ errors.first('CustomLink') }}</span>
        </div>
        <div class="vx-col md:w-1/2 w-full mt-4">
          <label>Table Type</label>
          <div class="w-full mt-5">
            <ul class="streaming-client-wrap">
              <li :class="data_local.TableType == 'Open' ? 'active' : ''">
                <vs-radio
                  v-model="data_local.TableType"
                  vs-value="Open"
                  @change="openCloseSpectate"
                  name="TableType"
                  color="#ffffff"
                  >Open</vs-radio
                >
              </li>
              <li :class="data_local.TableType == 'Pre_assigned' ? 'active' : ''">
                <vs-radio
                  class="ml-3"
                  v-model="data_local.TableType"
                  vs-value="Pre_assigned"
                  color="#ffffff"
                  @change="openCloseSpectate"
                  name="TableType"
                  >Pre-assigned</vs-radio
                >
              </li>
            </ul>
          </div>
        </div>

        <!-- <div
          class="vx-col md:w-2/12 w-full mt-4"
          v-if="
            data_local.StreamingClient == 'Web' && data_local.TableType == 'Open'
          "
        >
          <label>Spectate</label>
          <div class="mt-4">
            <vs-switch
              v-model="data_local.Spectate"
              :disabled="!spectateEnabled"
              name="Spectate"
            >
              <span slot="true">True</span>
              <span slot="false">False</span>
            </vs-switch>
          </div>
        </div> -->

        <div
          class="vx-col md:w-1/2 w-full mt-4"
          v-if="data_local.TableType == 'Open'"
        >
          <!--<label>Map To</label>-->
          <vs-checkbox v-model="data_local.MapTo.IsMapped" class="mr-4 mb-2"
            >Map To</vs-checkbox
          >
          <div class="w-full mt-5" v-show="data_local.MapTo.IsMapped">
            <!--<vs-radio class="ml-3" v-model="data_local.MapTo.Type" vs-value="Attendee">Attendee</vs-radio>-->
            <vs-radio
              class="ml-3"
              v-model="data_local.MapTo.Type"
              vs-value="Exhibitor"
              :disabled="$route.params.roundtableId"
              >Exhibitor</vs-radio
            >
            <vs-radio
              class="ml-3"
              v-model="data_local.MapTo.Type"
              vs-value="Sponsor"
              :disabled="$route.params.roundtableId"
              >Sponsor</vs-radio
            >
          </div>
        </div>

        <div
          class="vx-col md:w-1/2 w-full mt-4"
          v-if="data_local.TableType == 'Open' && data_local.MapTo.IsMapped"
        >
          <label>{{ data_local.MapTo.Type }}</label>
          <v-select
            class="mt-3"
            v-model="data_local.MapTo.Entity"
            label="Name"
            :options="mappedEntityList"
            :disabled="$route.params.roundtableId"
            :dir="$vs.rtl ? 'rtl' : 'ltr'"
          />
        </div>
      </div>
      <div class="vx-row">
        <div class="vx-col md:w-1/2 w-full mt-4">
          <label>Is Published</label>
          <div class="mt-4">
            <vs-switch v-model="data_local.IsPublished" name="IsPublished">
              <span slot="true">True</span>
              <span slot="false">False</span>
            </vs-switch>
          </div>
        </div>

        <div class="vx-col md:w-1/2 w-full mt-4" v-if="data_local.StreamingClient == 'Web'">
        <label>Enable Breakout Room</label>
        <div class="mt-4">
          <vs-switch v-model="data_local.EnableBreakoutRoom" name="EnableBreakoutRoom">
            <span slot="true">True</span>
            <span slot="false">False</span>
          </vs-switch>
        </div>
      </div>

        <div class="vx-col md:w-1/2 w-full mt-4" v-if="preassigned_visibility">
          <label>Map Attendees</label>
          <v-select
            class="mt-3"
            multiple
            :closeOnSelect="false"
            v-model="data_local.MappedAttendees"
            label="Email"
            v-on:input="limiter"
            :options="mapattendessList"
            :dir="$vs.rtl ? 'rtl' : 'ltr'"
          />
        </div>

        <!--
        <div class="vx-col md:w-1/2 w-full mt-4" v-if="preassigned_visibility">
          <label>Pre-assigned Type</label>
          <div class="w-full mt-5">
            <vs-radio v-model="data_local.PreAssignedType" vs-value="Public">Public</vs-radio>
            <vs-radio class="ml-3" v-model="data_local.PreAssignedType" vs-value="Private">Private</vs-radio>
          </div>
        </div>
        -->
      </div>
    </div>
    <div class="tab-botttom-sticky-part">
      <!-- Save & Reset Button -->
      <div class="vx-row">
        <div class="vx-col w-full">
          <div class="mt-8 mb-8 flex flex-wrap items-center justify-end">
            <vs-button class="mt-2" @click="$router.push('/event/roundtables')"
              >Back To List</vs-button
            >
            <vs-button
              class="ml-auto mt-2"
              type="border"
              color="warning"
              @click="reset_data"
              >Reset</vs-button
            >
            <vs-button class="ml-4 mt-2" @click="before_save" color="success"
              >Save & Exit</vs-button
            >
          </div>
        </div>
      </div>
    </div>
    <vs-popup
      class="holamundo registrationType-popup"
      title="Crop Image"
      :active.sync="popupCropper"
      fullscreen="fullscreen"
      v-if="cropImageUrl"
    >
      <h5>
        Aspect Ratio for this image is {{ displayImageRatio }}. To crop this
        image, simply drag and click Upload
      </h5>
      <photowall-resize-component
        :key="resetCropper"
        v-bind:aspectValue="imageRatio"
        :sourceImage="cropImageUrl"
        @croppedImagePath="croppedImagePath"
      />
    </vs-popup>
  </div>
</template>

<script>
import vSelect from "vue-select";
import "quill/dist/quill.snow.css";
import { quillEditor } from "vue-quill-editor";

import moduleSessionManagement from "@/store/session-management/moduleSessionManagement.js";
import moduleAttendeeManagement from "@/store/attendee-management/moduleAttendeeManagement.js";
import moduleExhibitorManagement from "@/store/exhibitor-management/moduleExhibitorManagement.js";
import moduleSponsorManagement from "@/store/sponsor-management/moduleSponsorManagement.js";
import moduleroundtableManagement from "@/store/roundtable-management/moduleRoundtableManagement.js";
import PhotowallResizeComponent from "../photowall/PhotowallResizeComponent.vue";
import ls from "@/common/localStorage";

var vm;
var cn = ls.getSessionEventCollectionName();
export default {
  components: {
    vSelect,
    quillEditor,
    "v-select": vSelect,
    PhotowallResizeComponent,
  },
  props: {
    data: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      data_local: JSON.parse(JSON.stringify(this.data)),
      imgSrc: this.data.RoundtableLogo
        ? this.data.RoundtableLogo
        : "https://firebasestorage.googleapis.com/v0/b/e2monair.appspot.com/o/OA_UAT%2FDefaults%2Fimage%2Fe2m-logo-black.png?alt=media&token=1df64ca4-70bf-4f41-87c2-b5706f1e613d",

      tableId: "",
      tableName: "",
      TopicName: null,
      popupActive: false,
      TopicList: [],
      //preAssignedType:'Public',
      //table_type:'Open',
      spec_visibility: this.data.TableType == "Open" ? true : false,
      preassigned_visibility:
        this.data.TableType == "Pre_assigned" ? true : false,
      //Spectate:true,
      Host: [],
      CoHost: null,
      //attendessList: ['sumitava.das@webspider.com','sourav.ghosh@webspider.com','dipesh.majumdar@webspider.com','adsdf.das@webspider.com'],
      attendessList: [],
      mapattendessList: [],
      ORIGINALattendessList: [],
      //mappedEntityType: "",
      mappedEntityList: [],

      content: " ",
      tableCapacity: "2",
      TableCapacityOptions: [
        { text: "2", value: "2" },
        { text: "3", value: "3" },
        { text: "4", value: "4" },
        { text: "5", value: "5" },
        { text: "6", value: "6" },
        { text: "7", value: "7" },
        { text: "8", value: "8" },
        { text: "9", value: "9" },
        { text: "10", value: "10" },
        { text: "11", value: "11" },
        { text: "12", value: "12" },
        { text: "13", value: "13" },
        { text: "14", value: "14" },
        { text: "15", value: "15" },
        { text: "16", value: "16" },
      ],
      imageRatio: 2 / 1,
      cropImageUrl: null,
      resetCropper: 0,
      displayImageRatio: "2 / 1",
      popupCropper: false,
      uploadedFile: null,
    };
  },
  computed: {
    status_local: {
      get() {
        return {
          label: this.capitalize(this.data_local.status),
          value: this.data_local.status,
        };
      },
      set(obj) {
        this.data_local.status = obj.value;
      },
    },
    role_local: {
      get() {
        return {
          label: this.capitalize(this.data_local.role),
          value: this.data_local.role,
        };
      },
      set(obj) {
        this.data_local.role = obj.value;
      },
    },
    validateForm() {
      return !this.errors.any();
    },
    spectateEnabled() {
      return this.data_local.TableType == "Open";
    },
  },
  methods: {
    croppedImagePath(blob) {
      //this.imgSrc = blob;
      this.popupCropper = false;
      if (this.uploadedFile)
        vm.uploadImage(blob, `${cn}/RoundTables/LogoImage/`, this.uploadedFile);
    },
    update_avatar(input, fileWH, checkRatio = false) {
      debugger;
      // You can update avatar Here
      if (input.target.files && input.target.files[0]) {
        let file = input.target.files[0];
        this.uploadedFile = file;
        var metadata = {
          contentType: file.type,
        };

        let validImageTypes = ["image/gif", "image/jpeg", "image/png"];
        if (!validImageTypes.includes(file.type)) {
          alert("Only gif,jpeg & png file allowed.");
          return false;
        }
        let dimension = fileWH.split("x");
        var _URL = window.URL || window.webkitURL;
        let img = new Image();
        var objectUrl = _URL.createObjectURL(file);
        debugger;
        img.onload = function () {
          const reader = new FileReader();
          reader.onload = (e) => {
            vm.resetCropper += 1;
            vm.cropImageUrl = null;
            vm.cropImageUrl = e.target.result;
            vm.popupCropper = true;

            // vm.imgSrc = e.target.result;
          };
          reader.readAsDataURL(input.target.files[0]);

          _URL.revokeObjectURL(objectUrl);
        };
        img.src = objectUrl;
      }
    },
    uploadImage(fileBlob, target, file) {
      this.$vs.loading();
      this.$store
        .dispatch("sessionManagement/uploadFiles", [
          { blob: fileBlob, target: target, name: file.name, type: file.type },
        ])
        .then((res) => {
          this.$vs.loading.close();
          if (res.data.length && res.data[0].status == "fulfilled") {
            this.data_local.RoundtableLogo = res.data[0].value.url;
            this.imgSrc = res.data[0].value.url;
          } else {
            this.$vs.notify({
              color: "warning",
              position: "top-center",
              //title: "Session",
              text: "File not uploaded!",
            });
          }
        })
        .catch((err) => {
          this.$vs.loading.close();
          this.$vs.notify({
            color: "warning",
            position: "top-center",
            //title: "Session",
            text: "Something went wrong!",
          });
        });
    },
    limiter(e) {
      if (e.length > parseInt(this.data_local.Topic.TopicTableCapacity) - 1) {
        var attcnt = parseInt(this.data_local.Topic.TopicTableCapacity) - 1;
        e.pop();
        this.$vs.notify({
          color: "warning",
          position: "top-center",
          //title: "Round Table",
          text: "You can only select " + attcnt + " users!",
        });
      }
    },
    capitalize(str) {
      return str.slice(0, 1).toUpperCase() + str.slice(1, str.length);
    },
    before_save() {
      this.$validator.validateAll().then((result) => {
        if (result) {
          // if form have no errors
          this.save_changes();
        }
      });
    },
    save_changes() {
      /* eslint-disable */
      if (!this.validateForm) return;

      // Here will go your API call for updating data
      // You can get data in "this.data_local"
      this.data_local.RoundtableLogo = this.imgSrc;
      /* eslint-enable */
      this.$vs.loading();
      const Id = this.$route.params.roundtableId;
      if (Id) {
        this.$store
          .dispatch("roundtableManagement/updateRoundtable", {
            id: Id,
            data: this.data_local,
          })
          .then((res) => {
            this.$vs.loading.close();
            if (res.status == 200) {
              vm.data_local.MapToOld = vm.data_local.MapTo;
              //alert(res.message)
              this.$vs.notify({
                color: "success",
                position: "top-center",
                title: "Round Table",
                text: "Round Table updated successfully.",
              });
              this.$router.push("/event/roundtables/");
            } else {
              this.$vs.notify({
                color: "warning",
                position: "top-center",
                title: "Round Table",
                text: "Round Table not updated!",
              });
            }
          })
          .catch((err) => {
            this.$vs.loading.close();
            this.$vs.notify({
              color: "warning",
              position: "top-center",
              //title: "Session",
              text: "Something went wrong!",
            });
          });
      } else {
        this.$store
          .dispatch("roundtableManagement/addRoundtable", {
            data: this.data_local,
          })
          .then((res) => {
            this.$vs.loading.close();
            if (res.status == 200) {
              this.$vs.notify({
                color: "success",
                position: "top-center",
                title: "Round Table",
                text: "Round Table created successfully.",
              });
              this.$router.push("/event/roundtables/");
            } else {
              this.$vs.notify({
                color: "warning",
                position: "top-center",
                title: "Round Table",
                text: res.message,
              });
            }
          })
          .catch((err) => {
            this.$vs.loading.close();
          });
      }
    },
    addTopic() {
      /* eslint-disable */
      if (!this.TopicName) return;

      this.$vs.loading();
      this.$store
        .dispatch("roundtableManagement/addRoundtableTopic", {
          TopicName: this.TopicName,
          TableCapacity: this.tableCapacity,
        })
        .then((res) => {
          //alert(res.message)
          this.$vs.notify({
            color: "success",
            position: "top-center",
            title: "Round Table Topic",
            text: res.message,
          });
          this.$vs.loading.close();
          if (res.status == 200) {
            this.TopicName = "";
            this.popupActive = false;
            this.data_local.Topic = {
              TopicId: res.TopicObj.TopicId,
              TopicName: res.TopicObj.TopicName,
              TopicDisplayName:
                res.TopicObj.TopicName +
                " (" +
                res.TopicObj.TableCapacity +
                ")",
              TopicTableCapacity: res.TopicObj.TableCapacity,
            };
            this.fetch_roundtabletopics();
          }
        })
        .catch((err) => {
          //console.error(err)
        });
    },
    reset_data() {
      this.data_local = JSON.parse(JSON.stringify(this.data));
    },

    openCloseSpectate() {
      if (this.spec_visibility) {
        this.spec_visibility = false;
        this.preassigned_visibility = true;
      } else {
        this.spec_visibility = true;
        this.preassigned_visibility = false;
      }
    },
    getAttendees() {
      this.$store.dispatch("attendeeManagement/fetchAttendees").then((res) => {
        //this.attendessList = res;
        //console.log(res);
        this.attendessList = [];
        this.mapattendessList = [];
        for (let i = 0; i < res.length; i++) {
          if (res[i].IsPublished) {
            this.attendessList.push({
              AttendeeId: res[i].AttendeeId,
              Company: res[i].Company ? res[i].Company : "",
              Designation: res[i].Designation ? res[i].Designation : "",
              Email: res[i].Email,
              FirstName: res[i].FirstName ? res[i].FirstName : "",
              LastName: res[i].LastName ? res[i].LastName : "",
              Name: res[i].Name ? res[i].Name : "",
              Phone: res[i].Phone ? res[i].Phone : "",
              ProfilePictureURL: res[i].ProfilePictureURL
                ? res[i].ProfilePictureURL
                : "",
            });
          }
        }
        //this.mapattendessList = this.attendessList
        this.ORIGINALattendessList = this.attendessList;
        for (let i = 0; i < vm.data_local.MappedAttendees.length; i++) {
          vm.attendessList = vm.attendessList.filter((row) => {
            return (
              vm.data_local.MappedAttendees[i].AttendeeId != row.AttendeeId
            );
          });
        }
        vm.mapattendessList = vm.attendessList.filter((row) => {
          return vm.data_local.Host[0].AttendeeId != row.AttendeeId;
        });
        //console.log(this.attendessList);
      });
    },
    getExhibitors() {
      this.$store
        .dispatch("exhibitorManagement/fetchExhibitors")
        .then((res) => {
          this.mappedEntityList = [];
          for (let i = 0; i < res.length; i++) {
            //if (res[i].IsPublished) {
            this.mappedEntityList.push({
              Id: res[i].ExhibitorId,
              Name: res[i].Name,
            });
            //}
          }
          console.log(this.mappedEntityList);
        });
    },
    getMappedContacts(mappedEntityType, mappedEntity) {
      debugger;
      if (mappedEntityType.toLowerCase() == "exhibitor") {
        this.$store
          .dispatch("exhibitorManagement/fetchExhibitor", mappedEntity.Id)
          .then((res) => {
            debugger;
            this.attendessList = [];
            if (res.data != undefined) {
              if (res.data.MappedContacts != undefined) {
                if (res.data.MappedContacts.length > 0) {
                  for (let i = 0; i < res.data.MappedContacts.length; i++) {
                    var cotact = res.data.MappedContacts[i];
                    this.attendessList.push({
                      AttendeeId: cotact.AttendeeId,
                      Company: cotact.Company ? cotact.Company : "",
                      Designation: cotact.Designation ? cotact.Designation : "",
                      Email: cotact.Email ? cotact.Email : "",
                      FirstName: cotact.FirstName ? cotact.FirstName : "",
                      LastName: cotact.LastName ? cotact.LastName : "",
                      Name: cotact.Name ? cotact.Name : "",
                      Phone: cotact.Phone ? cotact.Phone : "",
                      ProfilePictureURL: cotact.ProfilePictureURL
                        ? cotact.ProfilePictureURL
                        : "",
                    });
                  }
                }
              }
            }
          });
      } else {
        this.$store
          .dispatch("sponsorManagement/fetchSponsor", mappedEntity.Id)
          .then((res) => {
            debugger;
            this.attendessList = [];
            if (res.data != undefined) {
              if (res.data.MappedContacts != undefined) {
                if (res.data.MappedContacts.length > 0) {
                  for (let i = 0; i < res.data.MappedContacts.length; i++) {
                    var cotact = res.data.MappedContacts[i];
                    this.attendessList.push({
                      AttendeeId: cotact.AttendeeId,
                      Company: cotact.Company ? cotact.Company : "",
                      Designation: cotact.Designation ? cotact.Designation : "",
                      Email: cotact.Email ? cotact.Email : "",
                      FirstName: cotact.FirstName ? cotact.FirstName : "",
                      LastName: cotact.LastName ? cotact.LastName : "",
                      Name: cotact.Name ? cotact.Name : "",
                      Phone: cotact.Phone ? cotact.Phone : "",
                      ProfilePictureURL: cotact.ProfilePictureURL
                        ? cotact.ProfilePictureURL
                        : "",
                    });
                  }
                }
              }
            }
          });
      }
    },
    getSponsors() {
      this.$store.dispatch("sponsorManagement/fetchSponsors").then((res) => {
        debugger;
        this.mappedEntityList = [];
        for (let i = 0; i < res.length; i++) {
          //if (res[i].IsPublished) {
          this.mappedEntityList.push({
            Id: res[i].SponsorId,
            Name: res[i].Name,
          });
          //}
        }
      });
    },
    fetch_roundtabletopics() {
      this.$store
        .dispatch("roundtableManagement/fetchRoundTableTopicDropdown")
        .then((res) => {
          this.TopicList = res;
          //console.log(res);
        });
    },
  },
  watch: {
    "data_local.TableType"(val) {
      if (val != "Open") {
        this.data_local.Spectate = false;
      }
    },
    "data_local.MapTo.Type"(val) {
      //this.mappedEntityType = val;
      debugger;

      //if (val.toLowerCase() == "attendee") {
      //  this.data_local.Host = [];
      //  this.data_local.MapTo.Entity = {};
      //  this.data_local.MappedAttendees = [];
      //  this.getAttendees();
      //} else
      if (val.toLowerCase() == "exhibitor") {
        //this.data_local.Host = [];
        this.data_local.MapTo.Entity = {};
        //this.data_local.MappedAttendees = [];
        //this.attendessList = [];
        this.getExhibitors();
      } else if (val.toLowerCase() == "sponsor") {
        //this.data_local.Host = [];
        this.data_local.MapTo.Entity = {};
        //this.data_local.MappedAttendees = [];
        //this.attendessList = [];
        this.getSponsors();
      }
    },
    "data_local.MapTo.Entity"(val) {
      ////this.mappedEntityType = val;
      //debugger;
      //this.data_local.Host = [];
      //this.data_local.MappedAttendees = [];
      //this.attendessList = [];
      //this.getMappedContacts(this.data_local.MapTo.Type, val);
    },
    "data_local.Host"(val) {
      vm.mapattendessList = vm.ORIGINALattendessList;
      if (vm.data_local.Host) {
        vm.mapattendessList = vm.mapattendessList.filter((row) => {
          return vm.data_local.Host[0].AttendeeId != row.AttendeeId;
        });
      }
    },
    "data_local.MappedAttendees"(val) {
      vm.attendessList = vm.ORIGINALattendessList;
      vm.mapattendessList = vm.ORIGINALattendessList;
      if (vm.data_local.MappedAttendees) {
        for (let i = 0; i < vm.data_local.MappedAttendees.length; i++) {
          vm.attendessList = vm.attendessList.filter((row) => {
            return (
              vm.data_local.MappedAttendees[i].AttendeeId != row.AttendeeId
            );
          });

          vm.mapattendessList = vm.mapattendessList.filter((row) => {
            return (
              vm.data_local.MappedAttendees[i].AttendeeId != row.AttendeeId
            );
          });
        }
      }
      if (vm.data_local.Host) {
        vm.mapattendessList = vm.mapattendessList.filter((row) => {
          return vm.data_local.Host[0].AttendeeId != row.AttendeeId;
        });
      }
    },
    /*"data_local.Topic"(val){
      this.Topic = this.TopicList.filter((row) => {
        return row.TopicId == val
      })
    }*/
  },
  created() {
    vm = this;
    if (!moduleAttendeeManagement.isRegistered) {
      this.$store.registerModule(
        "attendeeManagement",
        moduleAttendeeManagement
      );
      moduleAttendeeManagement.isRegistered = true;
    }
    this.getAttendees();
    if (!moduleExhibitorManagement.isRegistered) {
      this.$store.registerModule(
        "exhibitorManagement",
        moduleExhibitorManagement
      );
      moduleExhibitorManagement.isRegistered = true;
    }
    this.getExhibitors();
    if (!moduleSponsorManagement.isRegistered) {
      this.$store.registerModule("sponsorManagement", moduleSponsorManagement);
      moduleSponsorManagement.isRegistered = true;
    }
    if (!moduleroundtableManagement.isRegistered) {
      this.$store.registerModule(
        "roundtableManagement",
        moduleroundtableManagement
      );
      moduleroundtableManagement.isRegistered = true;
    }
    if (!moduleSessionManagement.isRegistered) {
      this.$store.registerModule("sessionManagement", moduleSessionManagement);
      moduleSessionManagement.isRegistered = true;
    }
    this.fetch_roundtabletopics();
    //console.log(this.$session.getAll())
  },
};
</script>
